import React from 'react';

export interface AutocompleteListBoxProps extends React.HTMLAttributes<HTMLUListElement> {
	hasNextPage?: boolean;
	isFetching?: boolean;
	loadMoreOptions?: () => Promise<void>;
}

const AutocompleteListBox = React.forwardRef<HTMLDivElement, AutocompleteListBoxProps>(
	(props, ref) => {
		const { children, hasNextPage, isFetching, loadMoreOptions, ...rest } = props;

		const handleScroll = (event: React.UIEvent<HTMLUListElement>) => {
			if (!loadMoreOptions) return;

			const listbox = event.currentTarget;

			// needs a threshold or won't reach the bottom
			const threshold = 10;
			const bottom =
				listbox.scrollHeight - listbox.scrollTop <=
				listbox.clientHeight + threshold;

			if (bottom && hasNextPage && !isFetching) {
				// Call loadMoreOptions when reaching bottom
				void loadMoreOptions();
			}
		};

		return (
			<div ref={ref}>
				<ul {...rest} onScroll={handleScroll}>
					{children}
				</ul>
			</div>
		);
	}
);

AutocompleteListBox.displayName = 'AutocompleteListBox';
export default AutocompleteListBox;
